import { Inject, Injectable } from '@angular/core';
import { PICS_CORE_SESSION_STORAGE, SessionStorageService } from '@pics-core/common-utils';

@Injectable({
  providedIn: 'root'
})
export class LocalService {
  constructor(
    @Inject(PICS_CORE_SESSION_STORAGE)
    private sessionStorageService: SessionStorageService
  ) {}

  public getItem(key: string): any {
    return this.sessionStorageService.getItem(key);
  }

  public setItem(key: string, item: any): void {
    return this.sessionStorageService.setItem(key, item);
  }

  public getObj(key: string, safe = true): any {
    return this.sessionStorageService.getObj(key, safe);
  }

  public setObj(key: string, item: any): void {
    return this.sessionStorageService.setObj(key, item);
  }

  public removeItem(key: string): void {
    this.sessionStorageService.removeItem(key);
  }

  public clear(): void {
    this.sessionStorageService.clear();
  }
  
  public asStorage(): any {
    return this.sessionStorageService.asStorage();
  }

  public keys(): string[] {
    return this.sessionStorageService.keys();
  }
  
}